import { z } from "zod";

declare const externalTextProvenance: unique symbol;

/** Open-vocabulary text authored outside Faro and validated at its boundary. */
export type ExternalText = string & {
  readonly [externalTextProvenance]: "external";
};

export const ExternalTextSchema = z
  .string()
  .transform((value): ExternalText => value as ExternalText);
